import { generateItems } from 'domain/common';
import { Session } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Session', Session);

export { actions, selectors, reducer };
